import css from './Header.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { IGoodServiceTicketData } from 'meta/pages/goodsandservices'

interface Props {
  data: IGoodServiceTicketData
  showFullDescriptionModal(show: boolean): void
}

const Header: React.FC<Props> = (props) => {
  const { data, showFullDescriptionModal } = props

  const { t } = useTranslation()

  const isDescTooLong = data.webDetails.length > 60

  return (
    <div className={css.wrapper}>
      <div className={css.title}>{data.notes}</div>
      <div className={css.description}>
        {!isDescTooLong && data.webDetails}
        {isDescTooLong && (
          <>
            {`${data.webDetails.substr(0, 57)}...`}
            <span
              className={css.read_more}
              onClick={() => {
                showFullDescriptionModal(true)
              }}
            >
              {t('goodsAndServices:read_more')}
            </span>
          </>
        )}
      </div>
    </div>
  )
}

export default Header
